import React from 'react'
import './index.css'

const Splash = () => {
    return (
        <div className='splash'>
            <div className='splash-logo'>JD Healthcare</div>
        </div>
    )
}

export default Splash